import { BaseApi } from '@/api/baseApi';
import { IReportRequest, IReportResponse, TEvent } from '@/types/events';

type TSearchEventsRequest = {
    search: string
}

type TAddEvetToUserReq = {
    uid: number
    eid: number
}

type TRemoveEvetToUserReq = {
    uid: number
    eid: number
    disabled: 1
}

export class Events extends BaseApi {
    public async getEventsList(): Promise<TEvent[]> {
        return await this.get<TEvent[]>('/list');
    }

    public async getUserEvents(): Promise<TEvent[]> {
        return await this.get<TEvent[]>('');
    }

    public async getEventsByUser(id: number): Promise<TEvent[]> {
        return await this.get<TEvent[], { uid: number }>('/by_uid', { uid: id });
    }

    public async addEventToUser(data: TAddEvetToUserReq): Promise<void> {
        await this.put<void, TAddEvetToUserReq>('', data);
    }

    public async removeEventToUser(data: Omit<TRemoveEvetToUserReq, 'disabled'>): Promise<void> {
        await this.delete<void, TRemoveEvetToUserReq>('', { ...data, disabled: 1 });
    }

    public async getReport(req: IReportRequest): Promise<IReportResponse> {
        return await this.get<IReportResponse, IReportRequest>('/report', req);
    }
}
